import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { trackPageview } from 'js/utils/tracking';
import { isDesktop } from 'js/utils/platformDetection';

import HeaderRegionGames from 'js/containers/header-region/HeaderRegion.games';
import SiteMetaData from 'js/components/generic/Generic.metadata';
import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';
import PageNotFound from 'js/page/Page.not_found';
import { getSiteMetaData } from 'js/store/app/App.selectors';
import { getGameByUrl } from 'js/store/games/Games.selectors';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

const PageIndividualGame = (props) => {
  const { game: gameSlug } = useParams();
  const game = useSelector((state) => getGameByUrl(state, gameSlug));
  const [isMobileDisplay, setIsMobileDisplay] = useState(() => !isDesktop());
  const defaultMeta = useSelector((state) => getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.games]));

  useEffect(() => {
    if (game) {
      trackPageview({ title: game.name, path: props.path });
    }
  }, [gameSlug, game]);

  useEffect(() => {
    const setDisplayType = () => setIsMobileDisplay(!isDesktop());

    window.addEventListener('resize', setDisplayType);
    return () => window.removeEventListener('resize', setDisplayType);
  }, []);

  if (!game) {
    return <PageNotFound />;
  }

  const {
    name = '',
    cta_image = '',
    header_title = '',
    header_description = '',
    header_image = '',
    game_title = '',
    game_src = '',
    game_seo = {},
    meta_title = '',
    meta_description = '',
    meta_keywords = '',
  } = game;

  const title = header_title || name || game_title;
  const description = header_description || game_seo.description || '';
  const playImage = cta_image || header_image || game_seo.image || game.default_image;
  const meta = {
    ...defaultMeta,
    title: meta_title || game_seo.title || defaultMeta.title,
    description: meta_description || game_seo.description || defaultMeta.description,
    keywords: meta_keywords || defaultMeta.keywords,
    og_image: playImage || defaultMeta.og_image,
    og_title: meta_title || game_seo.title || title || defaultMeta.og_title,
    og_description: meta_description || game_seo.description || description || defaultMeta.og_description,
  };

  return (
    <>
      <SiteMetaData {...meta} />
      <HeaderRegionGames title={title} description={description} image={header_image} />
      <div className="game--content-grid" style={{ paddingBottom: '80px' }}>
        <SvgTextureLineLong color={'#3996FF'} />
        <div className="container">
          <div className="watch--youtube-video">
            <SvgTextureLineLong color={'#fff'} />
            <div className="watch--youtube-video-inner">
              <h3>{name || game_title}</h3>
              <div className="watch--youtube-video-embed">
                {isMobileDisplay ? (
                  <a
                    href={`/games/${gameSlug}/mobile-play`}
                    aria-label={`Play ${name || game_title}`}
                    style={{ display: 'inline-flex' }}
                  >
                    <img src={playImage} alt={`Play ${name || game_title}`} />
                  </a>
                ) : (
                  <iframe title={`${name || game_title} game`} src={game_src} allow="autoplay; fullscreen"></iframe>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageIndividualGame;
